<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :timeout="4000"
      color="blue"
      top
      right
      multi-line
    >
      {{ snackbarMsg }}
    </v-snackbar>
      <v-form v-model="valid">
    <v-container>
      <v-row>

        <v-col
          cols="12"
          md="4"
        >
        <v-autocomplete
            v-model="copyFromDomain"
            :items="domains"
            label="Copy From Domain"
            outlined
            item-text="domain"
            return-object
          ></v-autocomplete>
          <v-text-field
            v-model="domainName"
            :rules="[() => !!domainName || 'This field is required']"
            label="Domain name"
            required
            outlined
          ></v-text-field>
               <v-select
                      :items="markets"
                      v-model="market"
                      label="Market"
                      item-text="code"
                      item-value="id"
                      return-object
                      outlined
                      :rules="[() => !!market || 'Market is required']"
                      required
                    >
                       <template slot="selection" slot-scope="data">
                                <div class="pr-2"> {{ data.item.market }}</div>
                                <gb-flag :code=data.item.market size="small" />
                       </template>
                      <template slot="item" slot-scope="data" >
                                <div class="pr-2"> {{ data.item.market }} </div>
                                <gb-flag :code=data.item.market size="small" />
                     </template>
                    </v-select>
          <v-select
            v-model="type"
            :items='["MAIN", "PBN"]'
            outlined
            label="Type"
          >
         
          </v-select>

            <v-text-field
            v-model="wordpressUser"
            label="Wordpress User"
            outlined
          ></v-text-field>
            <v-text-field
            v-model="wordpressPassword"
            label="Wordpress Password"
            outlined
          >
        </v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="border border-blue"></v-col>
        <v-col cols="12" md="4" >
              <v-switch
                v-model="controlSend"
                label="Control"
                color="primary"
              ></v-switch>
              <v-switch
                v-model="leadsSend"
                label="Leads"
                color="primary"
              ></v-switch>
              <v-switch
                v-model="beasttrackSend"
                label="Beasttrack"
                color="primary"
              ></v-switch>
              <v-switch
                v-model="backlySend"
                label="Backly"
                color="primary"
              ></v-switch>
          </v-col>
        </v-row>
        <v-row class="justify-center">
          <v-btn @click="addSite()"  color="primary" class="mt-2 c">
            Add site 
        </v-btn>
        </v-row>
     
    </v-container>
  </v-form>
  </v-container>
</template>

<style>
canvas {
  width: 100% !important;
  height: 600px !important;
}

tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

</style>

<script>
export default {
  data: function() {
    return {
      valid: false,
      users: [],
      tableLoading: true,
      search: "",
      copyFromDomain: "",
      snackbar: false,
      controlSend: true,
      beasttrackSend: true, 
      domains: [],
      backlySend: true,
      aifarmSend: true,
      leadsSend: true,
      snackbarMsg: "",
      domainName: "",
      wordpressUser: "",
      wordpressPassword: "",
      type: "MAIN",
      market: "",
      markets: [],
    };
  },

  created: function() {
      this.$store.dispatch('getMarkets')
       .then( async (response) => {
           console.log(response.data)
           this.markets = response.data.sort((a, b) => {
              const priority = { NL: 1, FI: 2, DE: 3 };
              const aPriority = priority[a.market] || 999;
              const bPriority = priority[b.market] || 999;
              return aPriority - bPriority;
            })
       }  )
       .catch(() => {
         this.snackbarMsg = "Error while loading markets data..."
         this.snackbar= true
       })
       
       this.$store.dispatch('getDomains')
       .then( async (response) => {
           console.log(response.data)
           this.domains = response.data
       })
       .catch(() => {
         this.snackbarMsg = "Error while loading domains data..."
         this.snackbar= true
       })

    },
    methods: {
         updatePermissions (userid, current_value){
                this.$store
                    .dispatch("updatePbnPermissions", {user_id: userid, current_value: current_value})
                    .then(async (response) => {
                    
                        this.snackbarMsg = response.data
                        this.snackbar = true
                    }).catch( (e) => {
                      this.snackbarMsg = e.response.data
                      this.snackbar = true
                    })
        },
        addSite(){
               this.$store
                    .dispatch("addSite", {domainName: this.domainName, wordpressUser: this.wordpressUser, wordpressPassword: this.wordpressPassword,
                      market:this.market,type: this.type, copyFromDomain: this.copyFromDomain, controlSend: this.controlSend, 
                      beasttrackSend: this.beasttrackSend, backlySend: this.backlySend, leadsSend: this.leadsSend, aifarmSend: this.aifarmSend})
                      .then(async (response) => {
                        if (response.data.errors && Array.isArray(response.data.errors)) {
                          const errs = response.data.errors.map(e => {
                            const msg = e?.error?.error || e?.error || '';
                            return e?.name ? `${e.name}: ${msg}` : msg;
                          }).filter(Boolean);
                          this.snackbarMsg = errs.join("\n");
                        } else {
                          this.snackbarMsg = 'Added';
                        }
                        this.snackbar = true
                    }).catch( (e) => {
                      this.snackbarMsg = e.response.data.msg
                      this.snackbar = true
                    })    
        }

    },
    watch: {
      copyFromDomain(newVal) {
        console.log(newVal)
        if (newVal && newVal.marketId) {
          const matchingMarket = this.markets.find(m => m.market === newVal.market || m.id === newVal.marketId);
          console.log(matchingMarket)
          if (matchingMarket) {
            this.market = matchingMarket;
          }
        }
        if (newVal && newVal.credentialId) {
          this.$store.dispatch('getCredentials', {credentialId: newVal.credentialId})
          .then(async (response) => {
            this.wordpressUser = response.data.username
            this.wordpressPassword = response.data.password
            console.log(response.data)
          })
          .catch(() => {
            this.snackbarMsg = "Error while loading credentials data..."
            this.snackbar = true
          })
        }
      }
    }

  }

</script>
